import React from "react";
import {connect} from "react-redux";
import {fetchUserInfo} from "../user/UserActions";
import {Dispatch} from "redux";
import {ContentModelName} from "../contenful/types";
import {fetchContent, fetchMultipleContent} from "../contenful/ContentfulActions";
import {AppState} from "../RootReducer";
import {AccountBalance, AppMode, CurrencyDefinition, UserInfo} from "../http/protocol";
import {LoginStatus} from "../http/Types";
import {getContainer} from "../ioc/IOCSetup";
import {fetchLastSeenBonusOfferId} from "../bonus/BonusActions";
import {getHasFetchedLastSeenBonusOffer} from "../selectors/messages-selector";
import {RequestState} from "../bonus/BonusReducer";
import {fetchRewards} from "../rewards/UserRewardActions";
import {Status, UserJourneyState} from "../journey/UserJourneyReducer";
import {fetchJourneys} from "../journey/UserJourneyActions";


type AllProps = PropsFromDispatch & PropsFromState;

export class UserDetails extends React.Component<AllProps>{
    componentDidMount(): void {
        this.props.fetchUserDetails();
        if(this.props.loggedIn && this.props.hasFetchedLastSeenBonusOffer == false) {
            this.props.fetchLastSeenBonusOfferId?.();
        }
        if(this.props.journey?.status === Status.NONE) {
            this.props.fetchJourney?.();
        }
    }



    componentDidUpdate(prevProps: AllProps): void {

        if(this.props.loggedIn && prevProps.loggedIn == false && this.props.hasFetchedLastSeenBonusOffer == false) {
            this.props.fetchLastSeenBonusOfferId?.();
        }
        if(this.props.loggedIn && prevProps.loggedIn == false && this.props.rewardsStatus == RequestState.NONE) {
            this.props.fetchRewards?.();
        }


    }

    render() {
        return <div></div>
    }
}

interface PropsFromState {
    balances?: AccountBalance[];
    lng: string;
    userInfo?: UserInfo;
    loggedIn: boolean;
    currencies?: CurrencyDefinition[];
    hasFetchedLastSeenBonusOffer? : boolean;
    rewardsStatus?: RequestState;
    journey?: UserJourneyState;
    appMode?: AppMode;
}

interface PropsFromDispatch {
    fetchUserDetails : () => void;
    fetchContent: typeof fetchContent;
    fetchMultipleContent: typeof fetchMultipleContent;
    activeCurrency?: string;
    fetchLastSeenBonusOfferId? : () => void;
    fetchRewards? : () => void;
    fetchJourney? : () => void;

}

let stateToProps = (state : AppState) => {
    let {user, settings} = state;
    return {
        rewardsStatus :state.rewards.rewardsStatus,
        balances : user.balances,
        activeCurrency : user.activeCurrency,
        lng: getContainer().getSettingsService().getActiveLocale().code,
        userInfo: user.user,
        loggedIn : LoginStatus.LOGGED_IN == user.status,
        currencies: settings.settings && settings.settings.currencies,
        hasFetchedLastSeenBonusOffer : getHasFetchedLastSeenBonusOffer(state),
        journey : state.journey,
        appMode : state.user.appMode
    }
};

let dispatchToProps = (dispatch : Dispatch) => ({
    fetchUserDetails : ()=>dispatch(fetchUserInfo() as any),
    fetchContent: (contentModelName: ContentModelName, locale?: string) => dispatch(fetchContent(contentModelName, locale) as any),
    fetchMultipleContent: (contentModelName: ContentModelName, locale?: string) => dispatch(fetchMultipleContent(contentModelName, locale) as any),
    fetchLastSeenBonusOfferId : () => dispatch(fetchLastSeenBonusOfferId() as any),
    fetchRewards : () => dispatch(fetchRewards() as any),
    fetchJourney : () => dispatch(fetchJourneys() as any)
});

export default connect(stateToProps, dispatchToProps)(UserDetails);